
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: [],
	listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'GESTAO_VM_GRUPO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'GESTAO_VM_GRUPO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'GESTAO_VM_GRUPO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'GESTAO_VM_GRUPO_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.map(item => ({
					id: item.id,
					valor: item.nome,
					id_tipo: item.id_tipo,
					controla_validade_rg: item.controla_validade_rg || false,
					controla_validade_cnh: item.controla_validade_cnh || false,
					controla_validade_mopp: item.controla_validade_mopp || false,
					controla_validade_aso: item.controla_validade_aso || false
				}))
			};

		case 'GESTAO_VM_GRUPO_TIPO_SELECT_LISTADO':
            return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
